import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree {
    const accessDetails = this.retrieveAccessDetails();
    const subscriptionDetails = this.retrieveSubscriptionDetails();
    const path = state.url.toLowerCase();

    const permissionMap: { [key: string]: string } = {
      'osint-image-search/face-compare': 'face_compare_permission',
      'osint-image-search/video-scanner': 'video_scanner_permission',
      'osint-image-search': 'face_search_permission',
      'osint-number-search': 'osint_search_permission',
      'osint-email-search': 'osint_search_permission',
      'gst-search': 'gst_search_permission',
      'gst-search-result': 'gst_search_permission',
      'din-search': 'din_search_permission',
      'din-search-result': 'din_search_permission',
      'mobile-pan-search': 'mobile_pan_search_permission',
      'mobile-pan-search-result': 'mobile_pan_search_permission',
      'phonepe-fastag-search': 'phonepe_fastag_search_permission',
      'phonepe-fastag-search-result': 'phonepe_fastag_search_permission',
      'phonepe-upi-search': 'phonepe_upi_search_permission',
      'phonepe-upi-search-result': 'phonepe_upi_search_permission',
      'leak-number-search': 'leak_search_permission',
      'leak-email-search': 'leak_search_permission',
      'leak-username-search': 'leak_search_permission',
      'leak-password-search': 'leak_search_permission',
      'link-analysis': 'link_analysis_permission',
      'pan-search': 'pan_search_permission',
      'vehicle-search': 'vehicle_search_permission',
    };

    const matchedEntry = Object.entries(permissionMap)
      .sort((a, b) => b[0].length - a[0].length)
      .find(([prefix]) => path.includes(`/${prefix}`));

    if (!matchedEntry) {
      return true;
    }

    const [, permissionKey] = matchedEntry;

    if (this.hasPermission(accessDetails, subscriptionDetails, permissionKey)) {
      return true;
    }

    return this.router.parseUrl('/not-allowed');
  }

  private hasPermission(
    accessDetails: any,
    subscriptionDetails: any,
    permissionKey: string,
  ): boolean {
    return Boolean(
      accessDetails?.[permissionKey] || subscriptionDetails?.[permissionKey],
    ) || (
      permissionKey === 'link_analysis_permission' &&
      accessDetails?.[permissionKey] !== false &&
      subscriptionDetails?.[permissionKey] !== false
    );
  }

  retrieveAccessDetails() {
    const USER_PORTAL = localStorage.getItem('USER_PORTAL');
    const userPortal = USER_PORTAL ? JSON.parse(USER_PORTAL) : null;

    return userPortal?.accessDetails || null;
  }

  retrieveSubscriptionDetails() {
    const USER_PORTAL = localStorage.getItem('USER_PORTAL');
    const userPortal = USER_PORTAL ? JSON.parse(USER_PORTAL) : null;

    return userPortal?.subscriptionDetails || null;
  }
}
